import p1 from "../images/p1.jpg";
import p2 from "../images/p2.jpg";
import p3 from "../images/p3.jpg";
import p4 from "../images/p4.jpg";
import p5 from "../images/p5.jpg";
import p6 from "../images/p6.jpg";
import p7 from "../images/p7.jpg";

const Data = [
    {
        imgsrc: p1,
        title:  "Web Development"
    },
    {
        imgsrc: p2,
        title:  "App Development"
    },
    {
        imgsrc: p3,
        title:  "Web Design"
    },
    {
        imgsrc: p4,
        title:  "Mobile App Development"
    },
    {
        imgsrc: p5,
        title:  "Software Development"
    },
    {
        imgsrc: p6,
        title:  "SEO"
    },
    {
        imgsrc: p7,
        title:  "Degital Marketing"
    }
];

export default Data